import React from 'react';
import cx from 'clsx';

import infoQuery from '../query/infoQuery';
import Layout from '../components/Layout';
import ContactForm from '../components/ContactForm';
import MapPin from '../components/Icons/MapPin';
import PhoneEmailMsg from '../components/CallToAction/PhoneEmailMsg';
import { googleMapAddressRouteWithProtocoal } from '../utils/static';
import { sendEvent } from '../utils/ga';
import * as themeStyles from '../assets/theme.module.scss';

const AboutRoute = ({ pageContext }) => {
    const {
        address, title,
    } = infoQuery();

    return (
        <Layout pageContext={pageContext}>
            <section className={cx(themeStyles.py6, themeStyles.pyMd6)}>
                <div className={themeStyles.container}>
                    <div className={cx(themeStyles.row, themeStyles.justifyContentCenter)}>
                        <div className={cx(themeStyles.col12, themeStyles.colMd10, themeStyles.colLg8, themeStyles.textCenter)}>
                            <h1 className={themeStyles.display3}>
                                聯絡我們
                            </h1>
                            <p className={cx(themeStyles.lead, themeStyles.mb0)}>
                                我們非常樂意回答您的任何問題
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className={cx(themeStyles.py7, themeStyles.pyMd9, themeStyles.borderBottom, themeStyles.borderGray300)} id="info">
                <div className={cx(themeStyles.container, themeStyles.mb6)}>
                    <PhoneEmailMsg textCenter />
                </div>
                <div className={cx(themeStyles.row, themeStyles.justifyContentCenter)}>
                    <div className={cx(themeStyles.col12, themeStyles.colMd10, themeStyles.colLg8, themeStyles.textCenter)}>
                        <p className={cx(themeStyles.mb2, 'vcenter', themeStyles.justifyContentCenter)}>
                            <a
                                className="vcenter"
                                href={googleMapAddressRouteWithProtocoal}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => sendEvent('Callout Contact Page', 'click', 'address')}
                            >
                                <MapPin />
                                {address}
                            </a>
                        </p>
                        <iframe title={title} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.1877983997806!2d120.22270301496692!3d22.980120684974537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e769eda08d4c9%3A0x5934d123c6117b14!2z5bu66Ie65pyJ6ZmQ5YWs5Y-4!5e0!3m2!1szh-TW!2sde!4v1564602812312!5m2!1szh-TW!2sde" width="600" height="450" frameBorder="0" style={{ border: 0 }} allowFullScreen />
                    </div>
                </div>
            </section>
            <ContactForm />
            {/* <div className="container mt-5">
                <h1>聯絡我們</h1>
                <p>電話：{phone1} / {phone2}</p>
                <p>{address}</p>
                <iframe title={title} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.1890673418543!2d120.2250238023393!3d22.98007400948599!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e769eda08d4c9%3A0x5934d123c6117b14!2z5bu66Ie65pyJ6ZmQ5YWs5Y-4!5e0!3m2!1szh-TW!2sde!4v1561305903451!5m2!1szh-TW!2sde" width="600" height="450" frameBorder="0" style={{ border: 0 }} allowFullScreen />
                <h2>讓我們</h2>
                <ContactForm/>
            </div> */}
        </Layout>
    );
};

export default AboutRoute;
